import { render, staticRenderFns } from "./model.vue?vue&type=template&id=dad7ba80&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"
import style0 from "./model.vue?vue&type=style&index=0&id=dad7ba80&prod&scoped=true&lang=scss"
import style1 from "./model.vue?vue&type=style&index=1&id=dad7ba80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad7ba80",
  null
  
)

export default component.exports